// ArmazenaPermissoesUsuario.js

import ArmazenaVariaveis from './ArmazenaVariaveis.js';

class ArmazenaPermissoesUsuario extends ArmazenaVariaveis {
  // Métodos adicionais específicos para a classe AppDataLogin, se necessário
  
  static  atualizarDados(objeto){
    super.atualizarDados2(objeto.permissoes_plataforma)
    
    super.atualizarDados(objeto.permissoes)
    // super.atualizarDados2(objeto.permissoes_plataforma)
  }
  
  
  static async PermissaoUsuario(entrada){
    await this.dados;
    if(this.dados.includes(entrada))
    {
        return true;
    }else{
        return false;
    }
  }
  static async PermissaoPlataforma(entrada){
    await this.dados2;
    if(this.dados2.includes(entrada))
    {
          return true;
    }else{
        return false;
    }
  }



  //permissoes possiveis

 




  static  Tipo = {
    PODE_INSERIR_USUARIO: 'PODE_INSERIR_USUARIO',
    PODE_EDITAR_USUARIO: 'PODE_INSERIR_USUARIO',
    PODE_APAGAR_USUARIO: 'PODE_INSERIR_USUARIO',
   
  };


}
 
export default ArmazenaPermissoesUsuario;
